var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-model"},[_c('div',{staticClass:"radio-out",class:_vm.select ? 'active-model' : '',on:{"click":_vm.checkSelect}},[_c('div',{staticClass:"radio-inner"})]),_vm._v(" "),_c('div',{staticClass:"title-text",class:_vm.select ? 'active-color' : ''},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }